export default __webpack_public_path__ + "static/media/emoji-france.bb7d6336.svg";